import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Popover } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';

// ----------------------------------------------------------------------

const ArrowStyle = styled('span')(({ theme }) => {
  const SIZE = 12;

  const POSITION = -(SIZE / 2);

  const borderStyle = `solid 1px ${theme.palette.grey[500_12]}`;

  return {
    zIndex: 1,
    width: SIZE,
    height: SIZE,
    content: "''",
    position: 'absolute',

    transform: 'rotate(-135deg)',
    background: theme.palette.background.paper,
    // Top Right
    borderRadius: '0 0 3px 0',
    top: POSITION,
    borderBottom: borderStyle,
    borderRight: borderStyle,
    right: theme.spacing(8),
  };
});

// ----------------------------------------------------------------------

TodoHistoryPopoverComponent.propTypes = {
  sx: PropTypes.object,
  children: PropTypes.node,
};

export default function TodoHistoryPopoverComponent({ children, sx, ...other }) {
  const smUp = useResponsive('up', 'sm');

  const anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'right',
  };

  const transformOrigin = {
    vertical: 'top',
    horizontal: 'right',
  }


  return (
    <Popover
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      PaperProps={{
        sx: {
          mt: 1,
          width: smUp ? '360px' : '100%',
          maxHeight: '410px',
          overflowY: 'scroll',
          overflowX: 'hidden',
          ...sx,
        },
      }}
      {...other}
    >
      {smUp && (<ArrowStyle />)}
      {children}
    </Popover>
  );
}
